import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CrmPromotionModule } from '../crm-promotion/crm-promotion.module';
import { ComponentProxyDirective } from '../deferred/component-proxy.directive';
import { CrmPromotionContainerComponent } from './crm-promotion-container.component';

@NgModule({
    imports: [CommonModule, CrmPromotionModule, ComponentProxyDirective],
    declarations: [CrmPromotionContainerComponent],
    exports: [CrmPromotionContainerComponent],
})
export class CrmPromotionContainerModule {}
